<script lang="ts">
	import './navbar.component.css';
	import type { Icon } from '../../interfaces/Icon';
	import type { Picture } from '../../interfaces/Picture';
	import ImageHandler from '../Image/ImageHandler.svelte';
	import type { ComponentType } from 'svelte';

	interface Props {
		icons?: Icon[];
		profilePicture: Picture;
		childComponents?: ComponentType[];
		logo: ComponentType;
	}

	let { icons = [], profilePicture, childComponents = [], logo }: Props = $props();

	const SvelteComponent_1 = $derived(logo);
</script>

<div class="vtmn-fixed vtmn-top-0 vtmn-block vtmn-text-content-primary vtmn-px-9 navbar">
	<nav class="vtmn-navbar" aria-label="Simple navbar">
		<div class="vtmn-navbar_left-navigation">
			<SvelteComponent_1 />
		</div>

		<div class="vtmn-navbar_right-navigation">
			{#each childComponents as component}
				{@const SvelteComponent_2 = component}
				<SvelteComponent_2 />
			{/each}
			{#each icons as value}
				<span
					id="vtmn-tooltip-5"
					class="vtmn-tooltip"
					data-tooltip={value.data.tooltip}
					data-position={value.data.position}
					role="tooltip"
				>
					<button class="vtmn-btn vtmn-btn--icon-alone vtmn-btn_variant--ghost">
						<span class="vtmn-sr-only">{value.name}</span>
						<span class={value.icon} aria-hidden="true"></span>
					</button>
				</span>
			{/each}
			<div class="vtmn-flex -space-x-2 vtmn-overflow-hidden vtmn-ml-2">
				<ImageHandler picture={profilePicture} placeHolderIcon="vtmx-user-line" />
			</div>
		</div>
	</nav>
</div>

<style src="./navbar.component.css"></style>
